import { render, staticRenderFns } from "./Movimentacao.vue?vue&type=template&id=44ab49f1&scoped=true&"
import script from "./Movimentacao.vue?vue&type=script&lang=js&"
export * from "./Movimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ab49f1",
  null
  
)

export default component.exports